'use strict';

var log = require('../../../../log/Log').channel('CmdBuf');
var AsciiText = require('./AsciiText');

var CmdBuf = function(receiveTerminators, unterminatedRegExp, extractCommand,
    negotiateTelnet) {
    this.command = '';
    this.telnetCommands = [];
    this.commands = [];
    this.negotiateTelnet = negotiateTelnet;
    this.allowEmptyCommands = false;
    this.terminators = receiveTerminators.slice();

    if (typeof unterminatedRegExp !== 'undefined' &&
        unterminatedRegExp !== null) {
        this.unterminatedRegExp = unterminatedRegExp;
    }

    if (typeof extractCommand === 'function') {
        this.extractCommand = extractCommand;
    }
};

/**
 * Add data to the command buffer.
 * @param {UInt8Array} The data to add
 */
CmdBuf.prototype.putUint8Array = function(data) {
    var str = AsciiText.decode(data);

    for (var i = 0, l = str.length; i < l; i++) {
        var c = str.charAt(i);

        if (this.negotiateTelnet &&
            this.command.length >= 2 &&
            this.command[this.command.length - 2] === '\xFF' &&
            (this.command[this.command.length - 1] === '\xFB' ||
             this.command[this.command.length - 1] === '\xFC' ||
             this.command[this.command.length - 1] === '\xFD' ||
             this.command[this.command.length - 1] === '\xFE')) {
            this.command += c;
            this.telnetCommands.unshift(this.command.slice(this.command.length - 3));
            this.command = this.command.slice(0, this.command.length - 3);
        } else if (this.terminators.includes(c)) {
            if (this.command.length > 0 || this.allowEmptyCommands) {
                this.commands.unshift(this.command);
                this.command = '';
            }
        } else {
            this.command += c;
        }
    }

    if (typeof this.unterminatedRegExp !== 'undefined') {
        var m;

        while ((m = this.unterminatedRegExp.exec(this.command)) !== null) {
            if (m[0].length === 0) break;
            this.commands.unshift(m[0]);
            this.command = this.command.substr(0, m.index) +
                this.command.substr(m.index + m[0].length);
        }
    }

    if (typeof this.extractCommand === 'function') {
        var res;

        while ((res = this.extractCommand(this.command)) !== null) {
            this.commands.unshift(res[0]);
            this.command = res[1];
        }
    }
};

/**
 * Check to see if the command buffer has any commands.
 * @return {Boolean} True if commands are in the buffer, false otherwise.
 */
CmdBuf.prototype.hasCommands = function() {
    return this.commands.length > 0;
};

/**
 * Check to see if the command buffer has any telnet commands.
 * @return {Boolean} True if commands are in the buffer, false otherwise.
 */
CmdBuf.prototype.hasTelnetCommands = function() {
    return this.telnetCommands.length > 0;
};

/**
 * Get the next command in the buffer.
 * @return {string} The command with terminators and any leading or
 * trailing whitespace removed.
 */
CmdBuf.prototype.getCommand = function() {
    if (this.commands.length > 0) {
        return this.commands.pop();
    }

    log.warning('getCommand: no commands to get');
    return '';
};

/**
 * Get the next telnet command in the buffer.
 * @return {string} The telnet command.
 */
CmdBuf.prototype.getTelnetCommand = function() {
    if (this.telnetCommands.length > 0) {
        return this.telnetCommands.pop();
    }

    log.warning('getTelnetCommand: no commands to get');
    return '';
};

/**
 * Clear the command buffer.
 */
CmdBuf.prototype.clear = function() {
    this.commands.length = 0;
    this.command = '';
};

module.exports = CmdBuf;
